import logo from './logo.svg';
import './App.scss';

import Papa from 'papaparse';
import { data } from './data/dataing-data';
import { data as newData } from './data/dating-data-latest';
import StatCard from './components/stat-card';
import { useState } from 'react';
import DifferenceBubble from './components/difference-bubble';

const csvDataOld = Papa.parse(data, {
  // header: true,
  // dynamicTyping: true,
  // transform: value => console.log(value)
});

const csvDataNew = Papa.parse(newData, {
  // header: true,
  // dynamicTyping: true,
  // transform: value => console.log(value)
});

function App() {

  // const [filters, setFilters] = useState({ gender: ['', ''], age: ['', ''], ideology: ['', ''], race: ['', ''], education: ['', ''] });
  const [filters, setFilters] = useState([
    { gender: '', age: '', ideology: '', race: '', education: '' },
    { gender: '', age: '', ideology: '', race: '', education: '' }
  ]);
  const [dataSet, setDataSet] = useState(true);
  const [showComparison, setShowComparison] = useState(false);

  const csvData = dataSet ? csvDataNew : csvDataOld;

  const filteredRowOne = csvData.data.filter((row) => row[0] == filters[0].gender && row[1] == filters[0].age && row[2] == filters[0].ideology && row[3] == filters[0].race && row[4] == filters[0].education);
  const filteredRowTwo = csvData.data.filter((row) => row[0] == filters[1].gender && row[1] == filters[1].age && row[2] == filters[1].ideology && row[3] == filters[1].race && row[4] == filters[1].education);

  // console.log(filteredRow);

  const output = [];
  if (filteredRowOne.length || filteredRowTwo.length) {
    const currentSliceOne = filteredRowOne.length > 0 && filteredRowOne[0].slice(5).map((val, idx) => [csvData.data[0][idx + 5], val]);
    const currentSliceTwo = filteredRowTwo.length > 0 && filteredRowTwo[0].slice(5).map((val, idx) => [csvData.data[0][idx + 5], val]);

    const rowCount = currentSliceOne.length || currentSliceTwo.length;

    const combinedSlices = [];
    for (let idx = 0; idx < rowCount; idx++) {
      combinedSlices.push([currentSliceOne ? currentSliceOne[idx][0] : currentSliceTwo[idx][0], currentSliceOne ? currentSliceOne[idx][1] : null, currentSliceTwo ? currentSliceTwo[idx][1] : null]);
    }

    output.push(
      <div className="row justify-content-start" key="start">
        <div className="col-3 d-none d-md-block"></div>
        <div className="col-12 col-sm-5 col-md-4 col-xl-4">
          {currentSliceOne && <h3 className="d-none d-sm-block">Less Likely to Date Someone Who:</h3>}
        </div>
        <div className="col-12 col-sm-2 col-md-1 text-center">
          {showComparison && currentSliceOne && currentSliceTwo && <h3 className="d-none d-md-block">Diff.</h3>}
        </div>
        <div className="col-12 col-sm-5 col-md-4 col-xl-4">
          {showComparison && currentSliceTwo && <h3 className="d-none d-sm-block">Less Likely to Date Someone Who:</h3>}
        </div>
      </div>
    )

    combinedSlices.sort((a, b) => {
      if (filteredRowOne.length) {
        return parseInt(b[1]) - parseInt(a[1]);
      }
      else {
        return parseInt(b[2]) - parseInt(a[2]);
      }
    });

    const results = combinedSlices.map((slice, idx) => {
      const marginClass = slice[1] && slice[2] ? 'mb-4' : 'mb-0';
      return (
        <div className={`row justify-content-center align-items-stretch ${marginClass} mb-sm-3 gx-0 gx-md-3 gy-2`} key={idx}>
          <div className="col-12 col-md-3 col-xl-3 d-flex align-items-center justify-content-center justify-content-md-end text-center text-md-right">
            {(showComparison || slice[1]) && <h5 className="mb-0">{slice[0]}</h5>}
          </div>
          <div className="col-12 col-sm-5 col-md-4 col-xl-4">
            {slice[1] && <StatCard title={slice[0]} percent={slice[1]} />}
          </div>
          <div className="col-12 col-sm-2 col-md-1 text-center">
            {showComparison && slice[1] && slice[2] && <DifferenceBubble percent={parseInt(slice[1]) - parseInt(slice[2])} />}
          </div>
          <div className="col-12 col-sm-5 col-md-4 col-xl-4">
            {showComparison && slice[2] && <StatCard title={slice[0]} percent={slice[2]} />}
          </div>
        </div>
      );
    });

    output.push(...results);
  }


  const updateFilters = (name, idx, value) => {
    if (true) {
      switch (value) {
        case "18 to 29 years":
        case "30 to 49 years":
        case "50 to 64 years":
        case "65 and older":
          name = "age";
          break;
        case "Liberal":
        case "Moderate":
        case "Conservative":
          name = "ideology";
          break;
        case "White, non-Hispanic":
        case "Black, non-Hispanic":
        case "Hispanic":
        case "Other or Multiracial":
          name = "race";
          break;
        case "High School or less":
        case "Some college or Associates":
        case "Bachelor's Degree +":
          name = "education"
      }

      const defaultFilters = { age: '', ideology: '', race: '', education: '' };
      const newFilters = [...filters];

      if (name == "gender" && value != '') {
        newFilters[idx] = { ...filters[idx], [name]: value };
      }
      else {
        newFilters[idx] = { ...filters[idx], ...defaultFilters, [name]: value };
      }

      setFilters(newFilters);
    }
    // else {
    //   const newFilters = [...filters];
    //   newFilters[idx] = { ...filters[idx], [name]: value };

    //   setFilters(newFilters);
    // }

  }


  return (
    <div className="App py-5">
      <div className="container">
        {/* <div className="form-check form-switch mb-2">
          <input className="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault" checked={dataSet} onChange={() => { setDataSet(!dataSet); setFilters({ gender: ['', ''], age: ['', ''], ideology: ['', ''], race: ['', ''], education: ['', ''] }) }} />
          <label className="form-check-label" for="flexSwitchCheckDefault">Use New Data Set</label>
        </div> */}
        <div className="row justify-content-start gx-0 gx-md-2 mb-4">
          {/* <div className="col-12 mb-2 mb-sm-4">
            <h1>Dating Liablilities</h1>
            <p>When it comes to dating, Americans have strong views about the things that matter to them. In the January 2023 American Perspectives Survey, we asked 5,055 Americans about their dating preferences, the qualities and the qualities they value and seek to avoid in a potential partner.</p>
            <p>Although some characteristics were nearly universally viewed as negative, such as smoking, there were considerable differences among some others, such as not having a college degree.</p>
            <p>To explore how dating priorities differ along the lines of gender, age, ideology, race, and education, select the categories to compare the extent to which the following are dating liabilities.</p>
          </div> */}

          <div className="col-3 d-none d-md-block"></div>
          <div className="col-12 col-sm-5 col-md-4 col-xl-4">
            {/* <p>I am:</p> */}
            <div className="form-check">
              <input className="form-check-input" type="checkbox" id="showComparison" onChange={(e) => { setShowComparison(e.target.checked) }} />
              <label className="form-check-label" for="showComparison">
                Show Comparison?
              </label>
            </div>
            {dataSet ?
              <>
                <select className="custom-select mb-3" aria-label="Default select example" value={filters[0].gender} onChange={(e) => updateFilters("gender", 0, e.target.value)}>
                  <option value="">Gender</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </select>
                <select className="custom-select mb-3" aria-label="Default select example" value={filters[0].age || filters[0].ideology || filters[0].race || filters[0].education} onChange={(e) => updateFilters("All", 0, e.target.value)} disabled={!filters[0].gender}>
                  <option value="">All</option>
                  <option value="18 to 29 years">18 to 29 years</option>
                  <option value="30 to 49 years">30 to 49 years</option>
                  <option value="50 to 64 years">50 to 64 years</option>
                  <option value="65 and older">65 and older</option>
                  <option value="Liberal">Liberal</option>
                  <option value="Moderate">Moderate</option>
                  <option value="Conservative">Conservative</option>
                  <option value="White, non-Hispanic">White, non-Hispanic</option>
                  <option value="Black, non-Hispanic">Black, non-Hispanic</option>
                  <option value="Hispanic">Hispanic</option>
                  <option value="High School or less">High School or less</option>
                  <option value="Some college or Associates">Some college or Associates</option>
                  <option value="Bachelor's Degree +">Bachelor's Degree +</option>
                </select>
              </>

              :

              <>
                <select className="custom-select mb-3" aria-label="Default select example" value={filters[0].gender} onChange={(e) => updateFilters("gender", 0, e.target.value)}>
                  <option value="">Gender</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </select>
                <select className="custom-select mb-3" aria-label="Default select example" value={filters[0].age} onChange={(e) => updateFilters("age", 0, e.target.value)}>
                  <option value="">Age</option>
                  <option value="18 to 29 years">18 to 29 years</option>
                  <option value="30 to 49 years">30 to 49 years</option>
                  <option value="50 to 64 years">50 to 64 years</option>
                  <option value="65 and older">65 and older</option>
                </select>
                <select className="custom-select mb-3" aria-label="Default select example" value={filters[0].ideology} onChange={(e) => updateFilters("ideology", 0, e.target.value)}>
                  <option value="">Ideology</option>
                  <option value="Liberal">Liberal</option>
                  <option value="Moderate">Moderate</option>
                  <option value="Conservative">Conservative</option>
                </select>
                <select className="custom-select mb-3" aria-label="Default select example" value={filters[0].race} onChange={(e) => updateFilters("race", 0, e.target.value)}>
                  <option value="">Race</option>
                  <option value="White, non-Hispanic">White, non-Hispanic</option>
                  <option value="Black, non-Hispanic">Black, non-Hispanic</option>
                  <option value="Hispanic">Hispanic</option>
                  <option value="Other or Multiracial">Other or Multiracial</option>
                </select>
                <select className="custom-select mb-3" aria-label="Default select example" value={filters[0].education} onChange={(e) => updateFilters("education", 0, e.target.value)}>
                  <option value="">Education</option>
                  <option value="High School or less">High School or less</option>
                  <option value="Some college or Associates">Some college or Associates</option>
                  <option value="Bachelor's Degree +">Bachelor's Degree +</option>
                </select>
              </>

            }
          </div>
          <div className="col-12 col-sm-2 col-md-1 text-center">

          </div>
          <div className="col-12 col-sm-5 col-md-4 col-xl-4">
            {/* <p>Compare To:</p> */}
            <div style={{ height: '26px' }}></div>
            {dataSet ?
              showComparison &&
              <>
                <select className="custom-select mb-3" aria-label="Default select example" value={filters[1].gender} onChange={(e) => updateFilters("gender", 1, e.target.value)}>
                  <option value="">Gender</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </select>
                <select className="custom-select mb-3" aria-label="Default select example" value={filters[1].age || filters[1].ideology || filters[1].race || filters[1].education} onChange={(e) => updateFilters("All", 1, e.target.value)} disabled={!filters[1].gender}>
                  <option value="">All</option>
                  <option value="18 to 29 years">18 to 29 years</option>
                  <option value="30 to 49 years">30 to 49 years</option>
                  <option value="50 to 64 years">50 to 64 years</option>
                  <option value="65 and older">65 and older</option>
                  <option value="Liberal">Liberal</option>
                  <option value="Moderate">Moderate</option>
                  <option value="Conservative">Conservative</option>
                  <option value="White, non-Hispanic">White, non-Hispanic</option>
                  <option value="Black, non-Hispanic">Black, non-Hispanic</option>
                  <option value="Hispanic">Hispanic</option>
                  <option value="High School or less">High School or less</option>
                  <option value="Some college or Associates">Some college or Associates</option>
                  <option value="Bachelor's Degree +">Bachelor's Degree +</option>
                </select>
              </>

              :

              <>
                <select className="custom-select mb-3" aria-label="Default select example" value={filters[1].gender} onChange={(e) => updateFilters("gender", 1, e.target.value)}>
                  <option value="">Gender</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </select>
                <select className="custom-select mb-3" aria-label="Default select example" value={filters[1].age} onChange={(e) => updateFilters("age", 1, e.target.value)}>
                  <option value="">Age</option>
                  <option value="18 to 29 years">18 to 29 years</option>
                  <option value="30 to 49 years">30 to 49 years</option>
                  <option value="50 to 64 years">50 to 64 years</option>
                  <option value="65 and older">65 and older</option>
                </select>
                <select className="custom-select mb-3" aria-label="Default select example" value={filters[1].ideology} onChange={(e) => updateFilters("ideology", 1, e.target.value)}>
                  <option value="">Ideology</option>
                  <option value="Liberal">Liberal</option>
                  <option value="Moderate">Moderate</option>
                  <option value="Conservative">Conservative</option>
                </select>
                <select className="custom-select mb-3" aria-label="Default select example" value={filters[1].race} onChange={(e) => updateFilters("race", 1, e.target.value)}>
                  <option value="">Race</option>
                  <option value="White, non-Hispanic">White, non-Hispanic</option>
                  <option value="Black, non-Hispanic">Black, non-Hispanic</option>
                  <option value="Hispanic">Hispanic</option>
                  <option value="Other or Multiracial">Other or Multiracial</option>
                </select>
                <select className="custom-select mb-3" aria-label="Default select example" value={filters[1].education} onChange={(e) => updateFilters("education", 1, e.target.value)}>
                  <option value="">Education</option>
                  <option value="High School or less">High School or less</option>
                  <option value="Some college or Associates">Some college or Associates</option>
                  <option value="Bachelor's Degree +">Bachelor's Degree +</option>
                </select>
              </>

            }

          </div>
        </div>
        {output}
      </div>
    </div>
  );
}

export default App;
